import { FunctionalComponent, h } from '@stencil/core';
import { href } from 'stencil-router-v2';
import range from 'lodash/range';
import { genAnchor } from '../shared/helpers'


interface AppPagination {
    searchParams: string;
    page: any;
    pageCount: any;
}


export const AppPagination: FunctionalComponent<AppPagination> = ({ searchParams, page, pageCount }) => {

    const limit = 5; // MUST be an odd number

    //use dots always show first and last but show first five then middle 5 then last
    const getCondensed = () => {


        if (pageCount < limit) {
            return [
                range(pageCount).map((i) => <li class={`${page == i + 1 ? 'uk-active' : ''}`}><a {...href(genAnchor(searchParams, i + 1))}>{i + 1}</a></li>)
            ]
        }
        else if (page < limit) {
            return [
                range(limit).map((i) => <li class={`${page == i + 1 ? 'uk-active' : ''}`}><a {...href(genAnchor(searchParams, i + 1))}>{i + 1}</a></li>),
                <li class="uk-disabled"><span>…</span></li>,
                <li><a {...href(genAnchor(searchParams, pageCount))}>{pageCount}</a></li>
            ]
        }
        else if (page > (pageCount - limit + 1)) {
            const startPage = pageCount - limit
            return [
                <li><a {...href(genAnchor(searchParams, 1))}>{1}</a></li>,
                <li class="uk-disabled"><span>…</span></li>,
                range(limit).map((i) => <li class={`${page == i + startPage + 1 ? 'uk-active' : ''}`}><a {...href(genAnchor(searchParams, i + startPage + 1))}>{i + startPage + 1}</a></li>),
            ]
        }
        else {
            const startPage = page - ((limit - 1) / 2) - 1
            return [
                <li><a aria-label='previous page' {...href(genAnchor(searchParams, 1))}>{1}</a></li>,
                <li class="uk-disabled"><span>…</span></li>,
                range(limit).map((i) => <li class={`${page == i + startPage + 1 ? 'uk-active' : ''}`}><a {...href(genAnchor(searchParams, i + startPage + 1))}>{i + startPage + 1}</a></li>),
                <li class="uk-disabled"><span>…</span></li>,
                <li><a aria-label='next page' {...href(genAnchor(searchParams, pageCount))}>{pageCount}</a></li>
            ]
        }
    }


    return (
        <ul class="uk-pagination uk-margin-medium-top uk-flex-center">
            <li class={`${page > 1 ? '' : 'uk-disabled'}`}><a aria-label='previous page' {...href(genAnchor(searchParams, page - 1))}><span uk-pagination-previous></span></a></li>
            {
                getCondensed()
            }
            <li class={`${page < pageCount ? '' : 'uk-disabled'}`}><a aria-label='next page' {...href(genAnchor(searchParams, page + 1))}><span uk-pagination-next></span></a></li>
        </ul>
    )
};
